import clsx from 'clsx';
import React from 'react';

import Divider from '@components/Divider';

import styles from './styles.module.scss';

const EmailConfirmation = ({
  message,
  renderExpirationText = false,
}: {
  message: string;
  renderExpirationText?: boolean;
}) => {
  return (
    <div className={clsx(styles.messageContainer, 'container')}>
      <div className="row">
        <div className="col-sm-12 col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2">
          <i className="fa fa-paper-plane-o"></i>
        </div>
      </div>
      <div className="row">
        <div
          className={clsx(
            styles.checkInbox,
            'col-sm-12 col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2'
          )}
        >
          <h2>Check your inbox</h2>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12 col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2">
          {message}
        </div>
      </div>
      {renderExpirationText && (
        <>
          <div className="row">
            <div className="col-sm-12 col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2">
              <Divider />
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2">
              This link will expire in 2 hours so don&apos;t wait too long!
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default EmailConfirmation;
